import http from "api/https";

// Получить все типы документов
export const getDocumentTypes = (): Promise<any> => {
  return http.get("/DocumentType/GetAll");
};

// Получить только активные типы документов
export const getActiveDocumentTypes = (): Promise<any> => {
  return http.get("/DocumentType/active");
};

// Получить обязательные типы документов
export const getRequiredDocumentTypes = (): Promise<any> => {
  return http.get("/DocumentType/required");
};

// Получить один тип документа по ID
export const getDocumentType = (id: number): Promise<any> => {
  return http.get(`/DocumentType/GetOneById?id=${id}`);
};

// Получить тип документа по коду
export const getDocumentTypeByCode = (code: string): Promise<any> => {
  return http.get(`/DocumentType/by_code/${code}`);
};

// Получить типы документов с пагинацией
export const getDocumentTypesPaginated = (pageSize: number, pageNumber: number): Promise<any> => {
  return http.get(`/DocumentType/GetPaginated?pageSize=${pageSize}&pageNumber=${pageNumber}`);
};

// Создать новый тип документа
export const createDocumentType = (data: any): Promise<any> => {
  return http.post("/DocumentType/Create", data);
};

// Обновить тип документа
export const updateDocumentType = (data: any): Promise<any> => {
  return http.put(`/DocumentType/Update`, data);
};

// Удалить тип документа
export const deleteDocumentType = (id: number): Promise<any> => {
  return http.remove(`/DocumentType/Delete?id=${id}`,{});
};

// Активировать/деактивировать тип документа
export const toggleDocumentTypeStatus = (id: number, is_active: boolean): Promise<any> => {
  return http.patch(`/DocumentType/${id}/toggle_status`, { is_active });
};

// Обновить порядок сортировки
export const updateDocumentTypeSortOrder = (id: number, sort_order: number): Promise<any> => {
  return http.patch(`/DocumentType/${id}/sort_order`, { sort_order });
};

// Массовое обновление порядка сортировки
export const bulkUpdateSortOrder = (items: Array<{ id: number; sort_order: number }>): Promise<any> => {
  return http.put("/DocumentType/bulk_sort_order", { items });
};